import { render, staticRenderFns } from "./topNavSetting.vue?vue&type=template&id=1c35e036&scoped=true&"
import script from "./topNavSetting.vue?vue&type=script&lang=js&"
export * from "./topNavSetting.vue?vue&type=script&lang=js&"
import style0 from "./topNavSetting.vue?vue&type=style&index=0&id=1c35e036&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c35e036",
  null
  
)

export default component.exports